import { notificationMatchesActiveContext } from '../../lib/notifications/matchesActiveContext'
import type { PersonalNotification } from './types'

/**
 * Unread badge count after suppressing rows the user is already viewing.
 * Server count is source of truth; matching unread items are deducted until
 * auto-mark-read catches up.
 */
export function countUnreadOutsideActiveContext(
  serverUnread: number,
  items: PersonalNotification[] | undefined,
  pathname: string,
  search: string,
): number {
  if (serverUnread <= 0) return 0
  if (!items?.length) return serverUnread

  const suppressed = items.reduce((n, item) => {
    if (item.read_at) return n
    if (!notificationMatchesActiveContext(item.payload.deep_link, pathname, search)) {
      return n
    }
    return n + 1
  }, 0)

  return Math.max(0, serverUnread - suppressed)
}
